"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _portalAdministration = require("./portalAdministration.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var tourPropertiesReducer = function tourPropertiesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _portalAdministration.LOAD_CUSTOM_TOUR_PROPERTIES_FOR_PORTAL_SUCCESS:
    case _portalAdministration.UPDATE_CUSTOM_TOUR_PROPERTIES_FOR_PORTAL_SUCCESS:
      {
        var _action$body = action.body,
            portalId = _action$body.portalId,
            _action$body$properti = _action$body.properties,
            properties = _action$body$properti === void 0 ? {} : _action$body$properti;
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, portalId, properties));
      }

    default:
      {
        return state;
      }
  }
};

var _default = tourPropertiesReducer;
exports["default"] = _default;